export const DragAndDropTypes = {
  Book: 'Book',
  DoublePage: 'DoublePage',
  Collectible: 'Collectible',
}
